module.exports = __webpack_public_path__ + "static/media/twitter.a50716dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 12
// module chunks = 0